//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../../../views/common-components/file-uploader';
import { formatDate } from '../../../../lib/date';
import {
    getRoomOwnerById,
    updateRoomOwner,
    savePropertyCertificate,
    saveRoomContract
} from '../../../../api/owner';

export default {
    name: 'page-detail-contract',
    components: { fileUploader },
    props: {
        // roomOwner: {
        //     required: true,
        //     type: Object,
        //     default: function() {
        //         return {
        //             id: 0,
        //             contract: {
        //                 addAttrIds: [],
        //                 delAttrIds: []
        //             },
        //             certificate: {
        //                 addAttrIds: [],
        //                 delAttrIds: []
        //             }
        //         };
        //     }
        // },
        roomOwnerId: {
            required: true,
            type: Number
        }

    },
    filters: {
        formatDate(time, type) {
            let date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            roomOwnerInfo: {
                id: 0,
                contract: {
                    addAttrIds: [],
                    delAttrIds: []
                },
                certificate: {
                    addAttrIds: [],
                    delAttrIds: []
                }
            },
            certificateModal: false,
            contractModal: false,
            roomOwnerInputDto: {
                id: 0,
                contract: {
                    addAttrIds: [],
                    delAttrIds: []
                },
                certificate: {
                    addAttrIds: [],
                    delAttrIds: []
                }
            }
        };
    },
    methods: {
        getRoomOwnerById() {
            if (this.roomOwnerId <= 0) {
                return;
            }
            console.log(this.roomOwnerId);
            getRoomOwnerById(this.roomOwnerId).then(res => {
                this.roomOwnerInfo = {};
                this.roomOwnerInfo = res.data.result;
                this.roomOwnerInfo.contract = {
                    addAttrIds: [],
                    delAttrIds: []
                };
                this.roomOwnerInfo.certificate = {
                    addAttrIds: [],
                    delAttrIds: []
                };

                this.roomOwnerInputDto = JSON.parse(JSON.stringify(this.roomOwnerInfo));

            });
        },
        handleRemove(data) {
            console.log(this.roomOwnerInfo);
        },

        updateRoomOwner() {

        },
        /*保存产证*/
        savePropertyCertificate() {
            console.log(this.roomOwnerInputDto);
            savePropertyCertificate(this.roomOwnerInputDto).then(res => {
                this.certificateModal = false;
                this.getRoomOwnerById();
                this.$refs.certificateRef.loadBeforeFiles(true);
            });
        },
        issueDateChange(date) {
            this.roomOwnerInputDto.issueDate = date;
        },
        receiveDateChange(date) {
            this.roomOwnerInputDto = date;
        },
        dataTransferTimeChange(date) {
            this.roomOwnerInputDto.dataTransferTime = date;
        },

        saveRoomContract() {
            saveRoomContract(this.roomOwnerInputDto).then(res => {
                this.contractModal = false;
                this.getRoomOwnerById();
                this.$refs.contractRef.loadBeforeFiles(true);
            });
        }
    },
    created() {

        this.getRoomOwnerById();
        // this.roomOwner.contract = {
        //     addAttrIds: [],
        //     delAttrIds: []
        // };
        // this.roomOwner.certificate = {
        //     addAttrIds: [],
        //     delAttrIds: []
        // };
    },
    watch: {
        roomOwnerId() {
            this.getRoomOwnerById();
        }
    }
};
